import { lazy, Suspense } from 'react';
import useIdentityContext from '../hooks/useIdentityContext';
import {
  MY_ACCOUNT_PAGE_SECTION,
  MY_ACCOUNT_PAGE_STAGE,
} from '../constants/tracking';

import { useShopperId } from '../hooks/useShopperId';
import type { CartTenantDetails } from '@vp/om-express-checkout';
import { useSiteData } from '../hooks/useSiteData';

const ExpressCheckout = lazy(() =>
  import('@vp/om-express-checkout').then((module) => ({
    default: module.ExpressCheckout,
  }))
);
interface ExpressCheckoutWrapperProps {
  altCartId: string;
  cartTenantDetails: CartTenantDetails;
  showExpressCheckoutFlyout: boolean;
  setShowExpressCheckoutFlyout: (show: boolean) => void;
  pageName: string;
}

export const ExpressCheckoutWrapper = ({
  altCartId,
  cartTenantDetails,
  showExpressCheckoutFlyout,
  setShowExpressCheckoutFlyout,
  pageName,
}: ExpressCheckoutWrapperProps) => {
  const shopperId = useShopperId();
  const { auth } = useIdentityContext();
  const { locale } = useSiteData();
  return (
    <Suspense fallback={null}>
      <ExpressCheckout
        showExpressCheckout={showExpressCheckoutFlyout}
        setShowExpressCheckout={setShowExpressCheckoutFlyout}
        shopperId={shopperId || ''}
        locale={locale}
        auth={auth}
        pageDetails={{
          pageName,
          pageSection: MY_ACCOUNT_PAGE_SECTION,
          pageStage: MY_ACCOUNT_PAGE_STAGE,
        }}
        tenantDetails={cartTenantDetails}
        cartDetails={{
          type: 'alt',
          altCartId,
        }}
      />
    </Suspense>
  );
};
